<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--mypage is-hide">
            <header class="l-header l-header--top">
                <public-page-header />
            </header>
            <section class="l-content-area">
                <div class="l-content">
                    <section class="p-bloc p-bloc--mypage">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">
                                <section class="p-mypage">
                                    <div class="p-mypage__content">
                                        <div class="mypage-content">
                                            <div class="p-mypage__page mypage-bloc">
                                                <div class="mypage-bloc__content">
                                                    <div class="page__bloc page__bloc--terms c-kiyaku">
                                                        <div class="blog-page">
                                                            <article id="post-inner">
                                                                <header class="article-header">
                                                                    <h1>hubsynchってなに？</h1>
                                                                    <ul class="post-data">
                                                                        <li class="posted"><span
                                                                                class="data-h">POSTED&nbsp;:&nbsp;&nbsp;</span>2014.01.20
                                                                        </li>
                                                                    </ul>

                                                                    <sns-share-links />

                                                                    <div class="eyecatch-img">
                                                                        <span><img
                                                                                src="@/assets/img/static_pages/fukidashi_1_20131219.jpg"
                                                                                class="attachment-w860-h480 size-w860-h480 wp-post-image responsive-img"
                                                                                alt="fukidashi_1_20131219"></span>
                                                                    </div>
                                                                </header>

                                                                <p>hubsynch（ハブシンク）は、様々なサービスでご利用頂いているログイン機能付き決済マネージメントサービスです。<br>
                                                                    ショッピングをお楽しみ頂く方のための「hubsynch
                                                                    ユーザーアカウント」と、商品・サービスの販売などにご利用頂ける「hubsynch
                                                                    マーチャントアカウント」をご用意しております。ご購入頂く方はhubsynchユーザーアカウントをご利用頂き、商品やサービスをご購入すると、hubsynchがhubsynchマーチャントアカウントをご利用頂いている方の代行として代金の受け取り、およびご購入者管理を行います。
                                                                </p>
                                                                <p style="text-align: center;"><img
                                                                        class="aligncenter size-full wp-image-488 responsive-img"
                                                                        src="@/assets/img/static_pages/illust_nani_A.png"
                                                                        alt="illust_nani_A" width="860" height="380">
                                                                </p>
                                                                <p style="text-align: left;">
                                                                    hubsynch（ハブシンク）はhubsynchにご登録頂きました方（ユーザーアカウントをお持ちの方）の情報を管理しております。また、販売者様（マーチャントアカウントをお持ちの方）はご自身のサイトにログインされた方の情報について管理しております。
                                                                </p>
                                                                <p style="text-align: center;"><img
                                                                        class="aligncenter size-full wp-image-490 responsive-img"
                                                                        src="@/assets/img/static_pages/illust_nani_B1.png"
                                                                        alt="illust_nani_B1" width="860" height="390">
                                                                </p>
                                                                <p>&nbsp;hubsynch（ハブシンク）はhubsynchをご利用頂いている販売者様のすべてのサイトで共通のID,PWにてログインが可能になります。
                                                                </p>
                                                                <p style="text-align: center;"><img
                                                                        class="aligncenter size-full wp-image-494 responsive-img"
                                                                        src="@/assets/img/static_pages/illust_nani_B2.png"
                                                                        alt="illust_nani_B2" width="860" height="390">
                                                                </p>
                                                                <p>&nbsp;販売者様のサイトにおいては、販売者様サイトにおいてhubsynchユーザーアカウントをお持ちの方がログインを実行した後に、販売様サイトのユーザーと認識いたします。
                                                                </p>
                                                                <p style="text-align: center;"><img
                                                                        class="aligncenter size-full wp-image-492 responsive-img"
                                                                        src="@/assets/img/static_pages/illust_nani_B3.png"
                                                                        alt="illust_nani_B3" width="860" height="390">
                                                                </p>
                                                                <p>&nbsp;</p>
                                                                <p>ユーザーアカウントをお持ちの方が、ユーザー情報の変更を行うと、hubsynchをご利用頂いている販売者サイトの決済情報がすべて変更されます。
                                                                </p>
                                                                <p>次は「<router-link title="アカウントの種類について"
                                                                        :to="{ name: 'category.account' }">アカウントの種類について</router-link>」
                                                                </p>
                                                                <div class="hubsynch-index-block">
                                                                    <h3 class="hubsynch-index-title">hubsynchについて</h3>
                                                                    <nav class="hubsynch-index-menu below-title">
                                                                        <ul>
                                                                            <li><router-link class="active"
                                                                                    title="hubsynchってなに？"
                                                                                    :to="{ name: 'about.hubsynch' }">hubsynchってなに？</router-link>
                                                                            </li>
                                                                            <li><router-link title="アカウントの種類について"
                                                                                    :to="{ name: 'category.account' }">アカウントの種類について</router-link>
                                                                            </li>
                                                                            <li><router-link title="hubsynchの特長"
                                                                                    :to="{ name: 'hubsynch.strong.point' }">hubsynchの特長</router-link>
                                                                            </li>
                                                                            <li><router-link title="hubsynchのご利用方法"
                                                                                    :to="{ name: 'hubsynch.using' }">hubsynchのご利用方法</router-link>
                                                                            </li>
                                                                            <li><router-link title="hubsynchのしくみ"
                                                                                    :to="{ name: 'hubsynch.flow' }">hubsynchのしくみ</router-link>
                                                                            </li>
                                                                            <li><router-link title="ユーザーアカウントの登録方法"
                                                                                    :to="{ name: 'how.to.sign.up' }">ユーザーアカウントの登録方法</router-link>
                                                                            </li>
                                                                            <li><router-link title="ご利用手数料について"
                                                                                    :to="{ name: 'user.account.fee' }">ご利用手数料について</router-link>
                                                                            </li>
                                                                        </ul>
                                                                    </nav>
                                                                </div>
                                                                <div id="btn-contact-wrap" class="btn-wrap">
                                                                    <p class="txt">ご不明な点がございましたら、お問い合わせ下さい</p>
                                                                    <p class="btn"><router-link
                                                                            :to="{ name: 'contact.us' }">お問合せ</router-link>
                                                                    </p>
                                                                </div>
                                                            </article>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
            <Footer v-if="isLoggedIn"/>
            <PublicFooter v-else/>
        </div>
    </div>
</template>
<script setup>
import PublicPageHeader from "@/components/PublicPageHeader.vue";
import SnsShareLinks from "@/components/SnsShareLinks.vue";
import { ref, onBeforeMount } from "vue";
import { useSessionStore } from "@/stores/sessionStore";
import Footer from "@/components/Footer.vue";
import PublicFooter from "@/components/PublicFooter.vue";

const sessionStore = useSessionStore();
const isLoggedIn = ref(false);
onBeforeMount(async () => {
    isLoggedIn.value = sessionStore.isLoggedIn();
});

function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}
</script>